const routes = {
  goustoWebclient: {
    blog: {
      url: '/blog/',
      label: 'Blog',
    },
    boxPrices: {
      url: '/box-prices',
      label: 'Box Prices',
    },
    chooseRecipes: {
      url: '/menu',
      label: 'Choose Recipes',
      labelAlternative: 'This Week\'s Recipes',
    },
    cookbook: {
      url: '/cookbook',
      label: 'Cookbook',
    },
    details: {
      url: '/my-details',
      label: 'Details',
    },
    deliveries: {
      url: '/mydeliveries',
      label: 'Deliveries',
    },
    freeFood: {
      url: '/my-referrals',
      label: 'Free Food',
    },
    help: {
      url: '/help-centre',
      label: 'Help',
    },
    home: {
      url: '/',
      label: 'Home',
      highlightHeader: true,
    },
    jobs: {
      url: '/jobs',
      label: 'Jobs',
    },
    modernSlavery: {
      url: '/modern-slavery-statement',
      label: 'Modern Slavery Statement',
    },
    myGousto: {
      url: '/my-gousto',
      label: 'My Gousto',
      highlightHeader: true,
    },
    privacyPolicy: {
      url: '/privacy-and-cookies-policies',
      label: 'Privacy and Cookies Policies',
    },
    rateMyRecipes: {
      url: '/rate-my-recipes',
      label: 'Rate My Recipes',
    },
    subscription: {
      url: '/my-subscription',
      label: 'Subscription',
    },
    suppliers: {
      url: '/suppliers',
      label: 'Our Suppliers',
    },
    sustainability: {
      url: '/blog/sustainability',
      label: 'Sustainability',
      labelAlternative: 'We Care',
    },
    termsOfUse: {
      url: '/terms-of-use',
      label: 'Terms of use',
    },
    termsAndConditions: {
      url: '/terms-and-conditions',
      label: 'Terms of sale',
    },
  },
  external: {
    facebook: {
      url: 'http://www.facebook.com/goustocooking',
      label: 'Facebook',
      target: '_blank',
    },
    twitter: {
      url: 'https://twitter.com/goustocooking',
      label: 'Twitter',
      target: '_blank',
    },
    youtube: {
      url: 'https://www.youtube.com/UKGousto/',
      label: 'YouTube',
      target: '_blank',
    },
    instagram: {
      url: 'http://instagram.com/goustocooking',
      label: 'Instagram',
      target: '_blank',
    },
    playstore: {
      url: 'https://play.google.com/store/apps/details?id=uk.co.gousto.gousto&utm_source=global_co&utm_medium=prtnr&utm_content=Mar2515&utm_campaign=PartBadge&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1',
      label: 'Google Play Store',
      target: '_blank',
    },
    appstore: {
      url: 'https://geo.itunes.apple.com/gb/app/gousto-uks-no1-recipe-kit/id992607465?mt=8',
      label: 'App Store',
      target: '_blank',
    },
  },
}

export {
  routes,
}
